 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useLazyLoadQuery} from 'react-relay'
import MeetingSubscription from '~/subscriptions/MeetingSubscription'

import useSubscription from '../hooks/useSubscription'
import NotificationSubscription from '../subscriptions/NotificationSubscription'
import OrganizationSubscription from '../subscriptions/OrganizationSubscription'
import TaskSubscription from '../subscriptions/TaskSubscription'
import TeamSubscription from '../subscriptions/TeamSubscription'
import {RetroDemo} from '../types/constEnums'
import RetroMeeting from './RetroMeeting'

const query = graphql`
  query DemoMeetingRootQuery($meetingId: ID!) {
    viewer {
      meeting(meetingId: $meetingId) {
        ...RetroMeeting_meeting
      }
    }
  }
`

const DemoMeetingRoot = () => {
  useSubscription('DemoMeetingRoot', NotificationSubscription)
  useSubscription('DemoMeetingRoot', OrganizationSubscription)
  useSubscription('DemoMeetingRoot', TaskSubscription)
  useSubscription('DemoMeetingRoot', TeamSubscription)
  useSubscription('DemoMeetingRoot', MeetingSubscription, {meetingId: RetroDemo.MEETING_ID})
  const data = useLazyLoadQuery(query, {
    meetingId: RetroDemo.MEETING_ID
  })
  if (!_optionalChain([data, 'optionalAccess', _ => _.viewer, 'optionalAccess', _2 => _2.meeting])) return null
  return React.createElement(RetroMeeting, { meeting: data.viewer.meeting,} )
}
export default DemoMeetingRoot
